/**
 * Split a chart caption so the row count can stay on one line with "rows".
 *
 * At 300px, "Number of records by month of Updated At across all 13 rows"
 * wrapped with the last line being the single word "rows". The count and
 * that word are one unit.
 */
export const splitRowCount = (
  caption: string
): { before: string; count: string; after: string } | null => {
  const match = caption.match(/^(.*?)(\d[\d,]*(?: matching)? rows)(.*)$/);
  if (!match) return null;
  return { before: match[1], count: match[2], after: match[3] };
};
